module.exports = __webpack_public_path__ + "static/media/thirsday-in-german.a22635dd.png";